import { setButtonUrl } from 'designer/component/action/Api'
import { getDrawingURL } from 'utility/httpClient.util'

export const openDrawing = ({ action, data, config, state }) => {
  const { setDrawing } = state
  let { drawingPath } = action
  const drawingURL =
    getDrawingURL() ||
    (
      config.find(({ configCode }) => configCode === 'drawing_url') || {
        data: getDrawingURL(),
      }
    ).data
  let url = `${drawingURL}${drawingPath}`
  url = setButtonUrl(url, action, data)
  let openTab = window.open(url, '_blank')
  setDrawing(openTab)
  return { status: 200 }
}
